'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _products = require('ifeis-isomorphic/lib/redux/actions/products');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _fileReader = require('../../util/file-reader');

var _simpleHash = require('../../util/simple-hash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditProductController = function () {
  function EditProductController($ngRedux, $scope, $mdDialog, msgService) {
    _classCallCheck(this, EditProductController);

    this.svc = {
      $ngRedux: $ngRedux,
      $scope: $scope,
      $mdDialog: $mdDialog,
      msgService: msgService
    };

    this.activate();
  }

  _createClass(EditProductController, [{
    key: 'activate',
    value: function activate() {
      var _this = this;

      this.unsubscribe = this.svc.$ngRedux.connect((0, _mapStateToController2.default)(this.feisId, this.productId))(this);
      this.maxImages = 4;
      this.minDate = (0, _moment2.default)().add(1, 'days').toDate();

      this.svc.$scope.$watch('$ctrl.product', function (product) {
        _this.title = product.get('id') ? 'Editing: ' + product.get('name') : 'Create New Product';
        _this.model = _extends({
          name: '',
          amount: '',
          description: '',
          _retirementDate: product.get('retirementDate') && (0, _moment2.default)(product.get('retirementDate')).toDate() || (0, _moment2.default)().add(1, 'days').toDate()
        }, product.toJS());
        _this.files = [];
        _this.copy = _extends({}, _this.model);
      });

      this.svc.$scope.$on('$destroy', function (event) {
        _this.unsubscribe();
      });
    }
  }, {
    key: 'canSave',
    value: function canSave() {
      if (!this.$scope.productForm) return false;
      return !this.loading && this.$scope.productForm.$valid && this.$scope.productForm.$dirty && !angular.equals(this.model, this.copy);
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.svc.$mdDialog.hide(null);
    }
  }, {
    key: 'deleteImageAction',
    value: function deleteImageAction(image) {
      var _this2 = this;

      this.svc.$ngRedux.dispatch((0, _products.deleteImage)(this.feisId, this.model.id, image.id)).then(function (resp) {
        return resp.errors && _this2.svc.msgService.displayErrorMsg('Error deleting image: ' + resp.errors.statusText);
      }).catch(function (e) {
        return _this2.svc.msgService.displayErrorMsg('Error deleting image: ' + e);
      });
    }
  }, {
    key: 'fileSelected',
    value: function fileSelected(files) {
      var file = files[0];
      var name = (0, _simpleHash.simpleHash)(this.model.id + '-' + file.name);
      this.uploadImage(name, file.type, file);
    }
  }, {
    key: 'saveProduct',
    value: function saveProduct() {
      var _this3 = this;

      this.model.retirementDate = (0, _moment2.default)(this.model._retirementDate).endOf('day').tz(this.feis.get('tz')).valueOf();
      if (!this.model.id) {
        return this.svc.$ngRedux.dispatch((0, _products.addProduct)(this.feisId, this.model)).then(function (resp) {
          if (resp.errors) {
            _this3.svc.msgService.displayErrorMsg('Error creating product: ' + resp.errors.statusText);
          } else {
            _this3.svc.$mdDialog.hide();
          }
        }).catch(function (e) {
          return _this3.svc.msgService.displayErrorMsg('Error creating product: ' + e);
        });
      } else {
        return this.svc.$ngRedux.dispatch((0, _products.updateProduct)(this.feisId, this.model.id, this.model)).then(function (resp) {
          return resp.errors && _this3.svc.msgService.displayErrorMsg('Error updating product: ' + resp.errors.statusText);
        }).catch(function (e) {
          return _this3.svc.msgService.displayErrorMsg('Error updating product: ' + e);
        });
      }
    }
  }, {
    key: 'uploadImage',
    value: function uploadImage(name, type, imageFile) {
      var _this4 = this;

      if (!imageFile) {
        return;
      }

      (0, _fileReader.fileReader)(imageFile).then(function () {
        imageFile && _this4.svc.$ngRedux.dispatch((0, _products.uploadImage)(_this4.feisId, _this4.product.get('id'), name, type, imageFile)).then(function (resp) {
          return resp.errors && _this4.svc.msgService.displayErrorMsg('Error uploading image: ' + resp.errors.statusText);
        }).catch(function (e) {
          return _this4.svc.msgService.displayErrorMsg('Error uploading image: ' + e);
        });
      }).catch(function (error) {
        _this4.svc.msgService.displayErrorMsg('Error reading file: ' + error);
      });
    }
  }]);

  return EditProductController;
}();

exports.default = EditProductController;


//////////////////
// WEBPACK FOOTER
// ./product-list/edit-product/index.js
// module id = 492
// module chunks = 0